<template>
  <div class="content">
    <h1>{{ pageTitle }}</h1>
    <div class="content-body two-columns form-wrapper" v-if="assembledPartInfo">
      <div class="left">
        <div class="block">
          <!-- <div style="display: flex; flex-direction: row; justify-content: flex-end; gap: 12px;">
            <Button size="small" icon="md-document" type="warning" @click="handleAddBomClicked">Add BOM</Button>
          </div> -->
          <AssembledPartInfoForm v-if="assembledPartInfo && assembledPartInfo.id" :assembled-part-info="assembledPartInfo"></AssembledPartInfoForm>
          <span style="color: #9ea7b4;" v-if="assembledPartInfo">{{ $t('date') }}: {{ assembledPartInfo.created_at || assembledPartInfo.updated_at }}</span>
        </div>
        <div class="block margin-top-20">
          <h2 style="margin-top: 0">{{ $t('part.info.part_number') }}</h2>
          <PartNumberForm v-if="showPartNumberForm" :part="assembledPartInfo"></PartNumberForm>
          <span class="warning" v-else>{{ $t('part.info.ensure_part_is_reviewed_and_category_set') }}</span>
        </div>
      </div>
      <div class="right">
        <div class="block">
          <h2>{{ $t('mechanical.image') }}</h2>
          <div>
            <Uploader v-if="assembledPartId" @on-success="handleFileUploaded" :defaultFileList="thumbData" :model-id="assembledPartId" :model-type="modelType" :max-num="1" accept=".jpg, .jpeg, .png, .gif, .svg, .bmp" drag-drop></Uploader>
          </div>
        </div>

        <div class="block margin-top-20">
          <h2>BOM</h2>
          <router-link v-if="bom" :to="{ name: 'menu.bom.view', params: { bomId: bom.id } }" target="_blank">{{ bom.name }}</router-link>
          <router-link v-else :to="{ name: 'menu.bom.bom_list'}" target="_blank">{{ $t('bom_tool.new_bom') }}</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import AssembledPartInfoForm from './components/assembled-part-info-form'
import Uploader from '@/components/images/uploader'
import PartNumberForm from '@/view/part/components/forms/part-number-form'
import { uploadThumbnail } from '@/api/file'

export default {
  name: 'AssembledPartEdit',
  components: {
    AssembledPartInfoForm,
    Uploader,
    PartNumberForm
  },
  data () {
    return {
      assembledPartInfo: null,
      thumbData: [],
      modelType: 'manufacturer_part',
      bom: null
    }
  },
  computed: {
    assembledPartId: function () {
      return this.$route.params.partId
    },
    pageTitle () {
      document.title = this.$t('assembled.edit.title') + ' - ' + this.assembledPartInfo?.name
      return document.title
    },
    showPartNumberForm: function () {
      return this.assembledPartInfo && this.assembledPartInfo.reviewed === 1 && this.assembledPartInfo.category
    }
  },
  mounted () {
    this.getAssembledPartInfo(this.assembledPartId)
    this.getAssociatedBom(this.assembledPartId)
  },
  methods: {
    ...mapActions([
      'getAssembledPart',
      'getBomByAssemblyPartId'
    ]),
    getAssembledPartInfo (id) {
      this.getAssembledPart(id).then(resp => {
        this.assembledPartInfo = resp.data
        this.thumbData = resp.data.thumb
      })
    },
    getAssociatedBom (id) {
      this.getBomByAssemblyPartId(this.assembledPartId)
        .then(resp => {
          this.bom = resp.data
        })
    },
    handleFileUploaded (fileManaged) {
      uploadThumbnail(this.modelType, this.assembledPartId, fileManaged.id).then(resp => {
        this.$Message.success('Upload successfully!')
      })
    }
  },
  watch: {
    assembledPartId: function (newId) {
      if (newId) {
        this.getAssembledPartInfo(newId)
        this.getAssociatedBom(newId)
      }
    }
  }
}
</script>
